import { toAssetsExtUrl } from './assetsExtUrl';

export const ASSETS_EXT_HELPER_NAME = 'assetsExtUrl';

export const registerAssetsExtHelper = Handlebars => {
    Handlebars.registerHelper(ASSETS_EXT_HELPER_NAME, url => toAssetsExtUrl(typeof url === 'string' ? url : ''));
    return Handlebars;
};
